<template>
<div style="background: #f6f6f6;">
    <el-card class="box-card">
        <el-table :data="users" style="width: 100%;margin-top: 20px;">
            <el-table-column type="index" width="100" align="left">
            </el-table-column>
            <el-table-column property="cover" label="头像" width="130" align="center">
                <template slot-scope="scope">
                    <img :preview="scope.row.cover" v-if="scope.row.cover" style="width: 50px;height:50px;" :src=" scope.row.cover"></img>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="姓名" width="150" align="left">
            </el-table-column>
            <el-table-column prop="phone" label="手机号码" width="200" align="left">
            </el-table-column>
            <el-table-column prop="gender" label="性别" width="100" align="left">
            </el-table-column>
          

        </el-table>
        <div class="block" style="float: right;margin:30px;">
            <el-pagination :page-size="pageSize" @current-change="handleCurrentChange" layout="prev, pager, next" :total="counts">
            </el-pagination>
        </div>
    </el-card>
</div>
</template>

<script>
import AV from 'leancloud-storage'
import moment from 'moment'

export default {
    data() {
        return {
            counts: 0,
            pageSize: 5,
            currentPage: 1,
            users: []
        }
    },
    created() {
        this.fetchData()
    },

    methods: {

        handleCurrentChange(page) {
            this.currentPage = page
            this.fetchData()
        },

        fetchData() {
            new AV.Query('_User')
                .startsWith('username', 'wxc534f9ed8a9993da')
               
                .count()
                .then(c => {
                    this.counts = c
                })
            new AV.Query('_User')

                .startsWith('username', 'wxc534f9ed8a9993da')
               
                .descending('updatedAt')
                .limit(this.pageSize)
                .skip((this.currentPage - 1) * this.pageSize)
                .find()
                .then(users => {
                    let usersJSON = []
                    for (let i = 0; i < users.length; i++) {
                        let user = users[i]

                        usersJSON.push({
                            name: user.get('nickname'),
                            
                            id: user.id,
                            phone:user.get('phone'),
                            gender: user.get('gender')==1?'男':'女',
                          
                            cover: user.get('avatar'),

                            createdAt: moment(user.updatedAt).format('YYYY-MM-DD HH:mm:ss')
                        })
                    }
                    this.users = usersJSON
                    this.videosAV = users
                })
                .catch(alert)
        }
    }
}
</script>
